module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-specific-template",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "row specific-template-subheader"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.contact.full_name) + " - " + _vm._s(_vm.business_name))])])]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.show_form) ? _c('template-form', {
    staticClass: "internal-scroller",
    attrs: {
      "id": 'specific-template-form',
      "options": _vm.form_options,
      "template": _vm.current_template,
      "default_template_kind": _vm.template_kind
    },
    on: {
      "validation-success": _vm.updateSpecificTemplate
    }
  }) : _c('specific-templates-list', {
    attrs: {
      "flow": _vm.flow,
      "contact": _vm.contact
    },
    on: {
      "specific-template-edit": _vm.openSpecificTemplateForm,
      "specific-template-destroy": _vm.destroySpecificTemplate
    }
  }), _c('div', {
    staticClass: "no-email-actions",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.has_valid_email_actions),
      expression: "!has_valid_email_actions"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('template.feedback.noActions')))])])], 1), (_vm.show_form) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-gray",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('template.actions.save')))])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-138bcc54!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/specific_templates/modal.vue
// module id = 1014
// module chunks = 1